import React from "react";
import About from "./pages/About";
import Service from "./pages/Services";
import Support from "./pages/Support";
import Home from "./pages/Home";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { BrowserRouter, Routes, Route } from "react-router-dom";

const App = () => {
  return (
    // <div>Home</div>
    <BrowserRouter>
      <Header />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/Home" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Services" element={<Service />} />

        <Route path="/Support" element={<Support />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
};

export default App;
